import * as React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Home } from './routes/home';
import { SectionA } from './routes/section-a';
import { SectionB } from './routes/section-b';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route path="" element={<Home />} />
          <Route path="section-a" element={<SectionA />} />
          <Route path="section-b" element={<SectionB />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
